/**
 * Social profiles, in the order they should appear.
 *
 * Single source of truth: the header, contact page and footer all read this, so
 * a changed handle is one edit rather than three that drift apart.
 *
 * URLs are taken from the live site, not guessed.
 */

export interface SocialLink {
	/** Used to pick the icon in `SocialLinks.svelte`. */
	id: 'line' | 'facebook' | 'instagram';
	label: string;
	href: string;
}

export const SOCIAL_LINKS: SocialLink[] = [
	{ id: 'line', label: 'LINE', href: 'https://line.me/R/ti/p/@dutchpassion' },
	{ id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/dutchpassionthailand' },
	{ id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/dutchpassion.thailand/' }
];
